import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})

export class StorageService {
  constructor() {}

  setDataToLocalStorage(name: string, value: any) {
    //Return if name or value not exists, as saving null is not required
    if(!name || !value){
      return;
    }
    try{
      //If sent value is JSON, stringify and save the string
      if (value && typeof (value) === 'string') {
        localStorage.setItem(name, value);
      } else {
        if (name === 'selfDetails') {
          this.processSelfDetails(value);
        }
        localStorage.setItem(name, JSON.stringify(value));
      }
    }catch (err){
      const _ = err;
    }
  }

  private processSelfDetails(value: any) {
    let presentCompany = localStorage.getItem('presentCompany');
    if (presentCompany) {
      value.company = presentCompany;
    } else if (!value.company && (value.assignedTo || []).length) {
      value.company = value.assignedTo[0].company._id;
    }
    for (const assign of (value.assignedTo || [])) {
      if (value.company && assign.company?._id && (value.company.toString() === assign.company._id.toString())) {
        value.enrollmentType = assign.company.enrollmentType || value.enrollmentType;
      }
    }
  }

  getDataFromLocalStorage( item: any ): any {
    //We can return if item is not of type string
    if( !item || (typeof item !== 'string' )){
      return;
    }
    const localData = localStorage.getItem(String(item));
    if(!localData){
      return ;
    }
    try{
      //If it is valid JSON, parse and send
      return JSON.parse( localData );
    }catch (error){
      const _ = error;
      return localData;
    }
  }

  removeDataFromLocalStorage(item: any) {
    //We can return if item is not of type string
    if( !item || (typeof item !== 'string' )){
      return;
    }
    localStorage.removeItem(String(item));
  }

  clearLocalStorage() {
    //Clear entire storage, created by the domain
    localStorage.clear();
  }

  setDataToSessionStorage(name: string, value: any) {
    if (!name || !value) {
      return;
    }
    try {
      if (value && typeof value === 'string') {
        sessionStorage.setItem(name, value);
      } else {
        sessionStorage.setItem(name, JSON.stringify(value));
      }
    } catch (err) {
      const _ = err;
    }
  }

  getDataFromSessionStorage(item: any): any {
    if (!item || typeof item !== 'string') {
      return;
    }
    const sessionData = sessionStorage.getItem(String(item));
    if (!sessionData) {
      return;
    }
    try {
      return JSON.parse(sessionData);
    } catch (error) {
      const _ = error;
      return sessionData;
    }
  }

  removeDataFromSessionStorage(item: any) {
    if (!item || typeof item !== 'string') {
      return;
    }
    sessionStorage.removeItem(String(item));
  }

  clearSessionStorage() {
    sessionStorage.clear();
  }
  
}
